var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavBar'),_c('v-main',{staticStyle:{"padding":"0"}},[_c('router-view'),_c('FooterMobile',{staticClass:"hidden-lg-and-up"}),_c('FooterDesktop',{staticClass:"hidden-md-and-down"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }